//
//
//
//
//
//
//
//
//
//

export default {
  components: {},
  name: 'titlebox',
  data() {
    return {
      title: {
        name: '课程广场',
        url: 'javascript:;'
      }
    };
  },
  methods: {
    // ...mapActions()
  },
  watch: {},
  computed: {
    // ...mapGetters()
  },
  created() {},
  mounted() {}
};
